import { render } from "./OrganizationPage.vue?vue&type=template&id=5813dee6&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&lang=js"

import "./OrganizationPage.vue?vue&type=style&index=0&id=5813dee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5813dee6"]])

export default __exports__